export enum MavenVersion {
  '3_5' = '3.5',
  '3_8' = '3.8',
  '3_9' = '3.9'
}

export enum JavaVersion {
  '8_0' = '8.0',
  '11_0' = '11.0',
  '17_0' = '17.0'
}

export enum MuleRuntimeVersion {
  '4_4' = '4.4',
  '4_6' = '4.6',
  '4_7' = '4.7',
  '4_8' = '4.8',
  '4_9' = '4.9',
  '4_10' = '4.10',
  '4_11' = '4.11'
}

export enum DefaultVersion {
  javaVersion = JavaVersion['8_0'],
  mavenVersion = MavenVersion['3_8'],
  muleRuntimeVersion = MuleRuntimeVersion['4_8']
}

export enum AccountType {
  FLEX = 'flex',
  PRO = 'pro',
  PRO_PLUS = 'pro_plus',
  TEAM = 'team',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_MIGRATE = 'enterprise-migrate',
  ENTERPRISE_MIGRATE_ASSESS = 'enterprise-migrate-assess',
  ENTERPRISE_MIGRATE_ACCELERATE = 'enterprise-migrate-accelerate',
  ENTERPRISE_MIGRATE_REFACTOR = 'enterprise-migrate-refactor',
  EXEMPT = 'exempt'
}
